
if (window.location.pathname.includes("/collections/")) {
  const pathSegments = window.location.pathname.split('/');
  const collectionHandle = pathSegments[pathSegments.length - 1] || pathSegments[pathSegments.length - 2]; // in case the URL ends with a '/'
  sessionStorage.setItem('lastCollection', collectionHandle);
  // console.log(sessionStorage.getItem('lastCollection'));
} else {
  if (!window.location.pathname.includes("/products/")) {
    // console.log("not on collection page");
    sessionStorage.removeItem('lastCollection');
  }
}

document.addEventListener("DOMContentLoaded", function() {
  var linksWithDataAttribute = document.querySelectorAll('[data-url]');
  // console.log("linksWithDataAttribute", linksWithDataAttribute)
  linksWithDataAttribute.forEach(function(link) {
    link.addEventListener("click", function(e) {
      e.preventDefault(); // Prevent the default link behavior

      var dataFollowLink = link.getAttribute("data-url");

      if (dataFollowLink) {
        window.location.href = dataFollowLink; // Navigate to the data URL
      }
    });
  });
});

$(document).on('product:added product:removed', function() {
  $('.free-shipping-remaining-text').text('New Shipping Text');
});

// Quick add to cart
function addProductToCart(id, productId){
  const formData = {
    id: id,
    quantity: 1
  };

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: JSON.stringify(formData),
    dataType: 'json',
    headers: {
      'Content-Type': 'application/json'
    },
    beforeSend: function(){
      buttonLoading(productId)
    },
    success: function(cart) {
      buttonStopLoading(productId)
      
      $.getJSON('/cart.js', function(updatedCart) {
        document.dispatchEvent(new CustomEvent('cart:refresh', {
          detail: {
            cart: updatedCart
          }
        }));
      });        
        
      const cartDrawerElement = document.querySelector('#cart-drawer');
      if (cartDrawerElement) {
        cartDrawerElement.show();
      } 
        
    },
    error: function(errorThrown) {
      buttonStopLoading(productId)

        var r = jQuery.parseJSON(errorThrown.responseText);
        $(".error_" + pro_id).html("Error: " + r.description).show();
        setTimeout(function() {
            $(".error_" + pro_id).html("").hide(100);
        }, 3000);
      }
  });
  
}

function buttonLoading(productId){
  $(`.loading-${productId}`).removeClass('noopacity');
  $(`.add-text-${productId}`).addClass('noopacity');
  $(`.button-${productId}`).prop('disabled', true);
  $(`.button-${productId}`).addClass('button-disabled');
}
function buttonStopLoading(productId){
  $(`.loading-${productId}`).addClass('noopacity');
  $(`.add-text-${productId}`).removeClass('noopacity');
  $(`.button-${productId}`).prop('disabled', false);
  $(`.button-${productId}`).removeClass('button-disabled');
}

CONVERT_HARNESS_MAPPING = {
  "2XS": { patch: "100mm", d_ring: "25mm" },
  "XS": { patch: "100mm", d_ring: "25mm" },
  "S": { patch: "130mm", d_ring: "38mm" },
  "M": { patch: "130mm", d_ring: "38mm" },
  "L": { patch: "158mm", d_ring: "50mm" },
  "XL": { patch: "158mm", d_ring: "50mm" },
  "2XL": { patch: "158mm", d_ring: "50mm" }
}

EXPRESS_HARNESS_MAPPING = {
  "2XS": { patch: "100mm", d_ring: "25mm" },
  "XS": { patch: "100mm", d_ring: "25mm" },
  "S": { patch: "110mm", d_ring: "25mm" },
  "M": { patch: "130mm", d_ring: "38mm" },
  "L": { patch: "130mm", d_ring: "38mm" },
  "XL": { patch: "158mm", d_ring: "50mm" },
  "2XL": { patch: "158mm", d_ring: "50mm" }
}

SADDLE_BAGS_MAPPING = {
  "S": { patch: "110mm", d_ring: "25mm" },
  "L": { patch: "155mm", d_ring: "50mm" }
}

BACK_PACK_MAPPING = {
  "S": { patch: "110mm", d_ring: "" },
  "M": { patch: "110mm", d_ring: "" },
  "L": { patch: "110mm", d_ring: "" }
}

ORTHO_SMART_BED_MAPPING = {
  "S": { patch: "110mm", d_ring: "" },
  "M": { patch: "130mm", d_ring: "" },
  "L": { patch: "130mm", d_ring: "" },
  "XL": { patch: "130mm", d_ring: "" }
}

ORTHO_LOUNGER_MAPPING = {
  "M": { patch: "110mm", d_ring: "" },
  "L": { patch: "130mm", d_ring: "" },
  "XL": { patch: "130mm", d_ring: "" }
}

ORTHO_CALM_ELITE_BED_MAPPING = {
  "M": { patch: "110mm", d_ring: "" },
  "L": { patch: "130mm", d_ring: "" },
  "XL": { patch: "130mm", d_ring: "" }
}

THERMACORE_ORTHO_DOG_BED_MAPPING = {
  "S": { patch: "130x38 mm", d_ring: "" },
  "M": { patch: "130x38 mm", d_ring: "" },
  "L": { patch: "130x38 mm", d_ring: "" }
}

FORMFIT_MAPPING = {
  "2XS": { patch: "50mm", d_ring: "" },
  "XS": { patch: "50mm", d_ring: "" },
  "S": { patch: "65mm", d_ring: "" },
  "M": { patch: "65mm", d_ring: "" },
  "L": { patch: "80mm", d_ring: "" },
  "XL": { patch: "80mm", d_ring: "" }
}

DELUX_ORTHO_SMART_BED_COVER_MAPPING = {
  "S": { patch: "110mm", d_ring: "" },
  "M": { patch: "130mm", d_ring: "" },
  "L": { patch: "130mm", d_ring: "" },
  "XL": { patch: "130mm", d_ring: "" }
}

DELUX_ORTHO_LOUNGER_COVER_MAPPING = {
  "M": { patch: "110mm", d_ring: "" },
  "L": { patch: "130mm", d_ring: "" },
  "XL": { patch: "130mm", d_ring: "" }
}

DELUX_ORTHO_CALM_ELITE_BED_COVER_MAPPING = {
  "M": { patch: "110mm", d_ring: "" },
  "L": { patch: "130mm", d_ring: "" },
  "XL": { patch: "130mm", d_ring: "" }
}

ORTHO_SMART_BED_COVER_MAPPING = {
  "S": { patch: "110mm", d_ring: "" },
  "M": { patch: "130mm", d_ring: "" },
  "L": { patch: "130mm", d_ring: "" },
  "XL": { patch: "130mm", d_ring: "" }
}

ORTHO_LOUNGER_COVER_MAPPING = {
  "M": { patch: "110mm", d_ring: "" },
  "L": { patch: "130mm", d_ring: "" },
  "XL": { patch: "130mm", d_ring: "" }
}

ORTHO_CALM_ELITE_BED_COVER_MAPPING = {
  "M": { patch: "110mm", d_ring: "" },
  "L": { patch: "130mm", d_ring: "" },
  "XL": { patch: "130mm", d_ring: "" }
}

// Product IDS will be set under ids (convert harness will require getting all the convert harness ids for instance)
// Mapping from product size to patch/dring etc will be set up above

window.mapping = [
  {
    product: "Convert harness",
    ids: [8785890607400, 8785901584680, 8785899946280, 8785898176808],
    mapping: CONVERT_HARNESS_MAPPING
  },
  {
    product: "Express harness",
    ids: [8785890935080, 8785901682984, 8785900044584, 8785898307880],
    mapping: EXPRESS_HARNESS_MAPPING
  },
  {
    product: "Saddle bags",
    ids: [8785884709160],
    mapping: SADDLE_BAGS_MAPPING
  },
  {
    product: "Back pack",
    ids: [8785884578088],
    mapping: BACK_PACK_MAPPING
  },
  {
    product: "Ortho smart bed",
    ids: [8968431370536],
    mapping: ORTHO_SMART_BED_MAPPING
  },
  {
    product: "Ortho lounger",
    ids: [8968431436072],
    mapping: ORTHO_LOUNGER_MAPPING
  },
  {
    product: "Elite smart bed",
    ids: [8968431567144],
    mapping: ORTHO_CALM_ELITE_BED_MAPPING
  },
  {
    product: "Thermacore Orthopaedic Dog Bed",
    ids: [10266317291816],
    mapping: THERMACORE_ORTHO_DOG_BED_MAPPING
  },
  {
    product: "Formfit",
    ids: [9018885996840],
    mapping: FORMFIT_MAPPING
  },
  {
    product: "Deluxe Ortho Smart Dog Bed Cover",
    ids: [10286955495720],
    mapping: DELUX_ORTHO_SMART_BED_COVER_MAPPING
  },
  {
    product: "Deluxe Next Gen Ortho Lounger Dog Bed Cover",
    ids: [10286955430184],
    mapping: DELUX_ORTHO_LOUNGER_COVER_MAPPING
  },
  {
    product: "Deluxe Cover - 2 in 1 Ortho Calm Elite Dog Bed",
    ids: [10286955331880],
    mapping: DELUX_ORTHO_CALM_ELITE_BED_COVER_MAPPING
  },
  {
    product: "2 in 1 Ortho Smart Dog Bed Cover",
    ids: [10278448759080],
    mapping: ORTHO_SMART_BED_COVER_MAPPING
  },
  {
    product: "Next Gen Ortho Lounger Dog Bed Cover",
    ids: [10278448693544],
    mapping: ORTHO_LOUNGER_COVER_MAPPING
  },
  {
    product: "Ortho Calm Elite Dog Bed Replacement Cover",
    ids: [10278448628008],
    mapping: ORTHO_CALM_ELITE_BED_COVER_MAPPING
  }
  
]



/* new label customizations mappings by sudh */
CONVERT_HARNESS_MAPPING_NEW = {
 "S": { patch: "130mm", d_ring: "38mm" },
  "M": { patch: "130mm", d_ring: "38mm" },
  "L": { patch: "158mm", d_ring: "50mm" },
  "XXL": { patch: "158mm", d_ring: "50mm" },
  "XL": { patch: "158mm", d_ring: "50mm" },
  "2XL": { patch: "158mm", d_ring: "50mm" },
   "S": { patch: "130x38 mm", d_ring: "38mm" },
  "M": { patch: "130x38 mm", d_ring: "38mm" },
  "L": { patch: "158x50 mm", d_ring: "50mm" },
  "XXL": { patch: "158x50 mm", d_ring: "50mm" },
  "XL": { patch: "158x50 mm", d_ring: "50mm" },
  "2XL": { patch: "158x50 mm", d_ring: "50mm" }
}

EXPRESS_HARNESS_MAPPING_NEW = {
  "2XS": { patch: "100mm", d_ring: "25mm" },
  "XS": { patch: "100mm", d_ring: "25mm" },
  "S": { patch: "100mm", d_ring: "25mm" },
  "M": { patch: "130mm", d_ring: "38mm" },
  "L": { patch: "130mm", d_ring: "38mm" },
  "XL": { patch: "158mm", d_ring: "50mm" },
  "2XL": { patch: "158mm", d_ring: "50mm" },
  "2XS": { patch: "100x25 mm", d_ring: "25mm" },
  "XS": { patch: "100x25 mm", d_ring: "25mm" },
  "S": { patch: "100x25 mm", d_ring: "25mm" },
  "M": { patch: "130x38 mm", d_ring: "38mm" },
  "L": { patch: "130x38 mm", d_ring: "38mm" },
  "XL": { patch: "158x50 mm", d_ring: "50mm" },
  "2XL": { patch: "158x50 mm", d_ring: "50mm" },

}

SADDLE_BAGS_MAPPING_NEW = {
  "S": { patch: "110mm", d_ring: "25mm" },
  "L": { patch: "158mm", d_ring: "50mm" },
  "S": { patch: "110x30 mm", d_ring: "25mm" },
  "L": { patch: "158x50 mm", d_ring: "50mm" }
}

BACK_PACK_MAPPING_NEW = {
  "S": { patch: "110mm", d_ring: "" },
  "M": { patch: "110mm", d_ring: "" },
  "L": { patch: "110mm", d_ring: "" },
  "S": { patch: "110x30 mm", d_ring: "" },
  "M": { patch: "110x30 mm", d_ring: "" },
  "L": { patch: "110x30 mm", d_ring: "" }
}
ORTHO_SMART_BED_MAPPING_NEW = {
  "S": { patch: "110mm", d_ring: "" },
  "M": { patch: "130mm", d_ring: "" },
  "L": { patch: "130mm", d_ring: "" },
  "XL": { patch: "130mm", d_ring: "" },
  "S": { patch: "110x30 mm", d_ring: "" },
  "M": { patch: "130x38 mm", d_ring: "" },
  "L": { patch: "130x38 mm", d_ring: "" },
  "XL": { patch: "130x38 mm", d_ring: "" }
}

ORTHO_LOUNGER_MAPPING_NEW = {
  "M": { patch: "110mm", d_ring: "" },
  "L": { patch: "130mm", d_ring: "" },
  "XL": { patch: "130mm", d_ring: "" },
  "M": { patch: "110x30 mm", d_ring: "" },
  "L": { patch: "130x38 mm", d_ring: "" },
  "XL": { patch: "130x38 mm", d_ring: "" }
}

ORTHO_CALM_ELITE_BED_MAPPING_NEW = {
  "M": { patch: "110mm", d_ring: "" },
  "L": { patch: "130mm", d_ring: "" },
  "XL": { patch: "130mm", d_ring: "" },
  "M": { patch: "110x30 mm", d_ring: "" },
  "L": { patch: "130x38 mm", d_ring: "" },
  "XL": { patch: "130x38 mm", d_ring: "" }
}
THERMACORE_ORTHO_DOG_BED_NEW = {
  "S": { patch: "130x38 mm", d_ring: "" },
  "M": { patch: "130x38 mm", d_ring: "" },
  "L": { patch: "130x38 mm", d_ring: "" }
}

FORMFIT_MAPPING_NEW = {
  "2XS": { patch: "60mm", d_ring: "" },
  "XS": { patch: "60mm", d_ring: "" },
  "S": { patch: "75mm", d_ring: "" },
  "M": { patch: "75mm", d_ring: "" },
  "L": { patch: "95mm", d_ring: "" },
  "XXL": { patch: "95mm", d_ring: "" },
  "2XL": { patch: "95mm", d_ring: "" },
  "XL": { patch: "95mm", d_ring: "" },
  "2XS": { patch: "60 mm", d_ring: "" },
  "XS": { patch: "60 mm", d_ring: "" },
  "S": { patch: "75 mm", d_ring: "" },
  "M": { patch: "75 mm", d_ring: "" },
  "L": { patch: "95 mm", d_ring: "" },
  "XXL": { patch: "95 mm", d_ring: "" },
  "2XL": { patch: "95 mm", d_ring: "" },
  "XL": { patch: "95 mm", d_ring: "" }, 
}

FORMFIT_MAPPING_NEW_1 = {
  "2XS": { patch: "2XS/XS", d_ring: "" },
  "XS": { patch: "2XS/XS", d_ring: "" },
  "S": { patch: "S/M", d_ring: "" },
  "M": { patch: "S/M", d_ring: "" },
  "L": { patch: "L/XL", d_ring: "" },
  "XL": { patch: "L/XL", d_ring: "" },
    "XXL": { patch: "L/XL", d_ring: "" },
  "2XL": { patch: "L/XL", d_ring: "" },
}

DELUX_ORTHO_SMART_BED_COVER_MAPPING_NEW = {
  "S": { patch: "110x30 mm", d_ring: "" },
  "M": { patch: "130x38 mm", d_ring: "" },
  "L": { patch: "130x38 mm", d_ring: "" },
  "XL": { patch: "130x38 mm", d_ring: "" }
}

DELUX_ORTHO_LOUNGER_COVER_MAPPING_NEW = {
  "M": { patch: "110x30 mm", d_ring: "" },
  "L": { patch: "130x38 mm", d_ring: "" },
  "XL": { patch: "130x38 mm", d_ring: "" }
}

DELUX_ORTHO_CALM_ELITE_BED_COVER_MAPPING_NEW = {
  "M": { patch: "110x30 mm", d_ring: "" },
  "L": { patch: "130x38 mm", d_ring: "" },
  "XL": { patch: "130x38 mm", d_ring: "" }
}

ORTHO_SMART_BED_COVER_MAPPING_NEW = {
  "S": { patch: "110x30 mm", d_ring: "" },
  "M": { patch: "130x38 mm", d_ring: "" },
  "L": { patch: "130x38 mm", d_ring: "" },
  "XL": { patch: "130x38 mm", d_ring: "" }
}

ORTHO_LOUNGER_COVER_MAPPING_NEW = {
  "M": { patch: "110x30 mm", d_ring: "" },
  "L": { patch: "130x38 mm", d_ring: "" },
  "XL": { patch: "130x38 mm", d_ring: "" }
}

ORTHO_CALM_ELITE_BED_COVER_MAPPING_NEW = {
  "M": { patch: "110x30 mm", d_ring: "" },
  "L": { patch: "130x38 mm", d_ring: "" },
  "XL": { patch: "130x38 mm", d_ring: "" }
}

window.mappingnew = [
  {
    product: "Convert harness",
    ids: [8785890607400, 8785901584680, 8785899946280, 8785898176808],
    mappingnew: CONVERT_HARNESS_MAPPING_NEW
  },
  {
    product: "Express harness",
    ids: [8785890935080, 8785901682984, 8785900044584, 8785898307880],
    mappingnew: EXPRESS_HARNESS_MAPPING_NEW
  },
  {
    product: "Saddle bags",
    ids: [8785884709160],
    mappingnew: SADDLE_BAGS_MAPPING_NEW
  },
  {
    product: "Back pack",
    ids: [8785884578088],
    mappingnew: BACK_PACK_MAPPING_NEW
  },
  {
    product: "Ortho smart bed",
    ids: [8968431370536],
    mappingnew: ORTHO_SMART_BED_MAPPING_NEW
  },
  {
    product: "Ortho lounger",
    ids: [8968431436072],
    mappingnew: ORTHO_LOUNGER_MAPPING_NEW
  },
  {
    product: "Elite smart bed",
    ids: [8968431567144],
    mappingnew: ORTHO_CALM_ELITE_BED_MAPPING_NEW
  },
  {
    product: "Thermacore Orthopaedic Dog Bed",
    ids: [10266317291816],
    mappingnew: THERMACORE_ORTHO_DOG_BED_NEW
  },
  {
    product: "Formfit",
    ids: [9018885996840],
    mappingnew: FORMFIT_MAPPING_NEW
  },
  {
    product: "Deluxe Ortho Smart Dog Bed Cover",
    ids: [10286955495720],
    mappingnew: DELUX_ORTHO_SMART_BED_COVER_MAPPING_NEW
  },
  {
    product: "Deluxe Next Gen Ortho Lounger Dog Bed Cover",
    ids: [10286955430184],
    mappingnew: DELUX_ORTHO_LOUNGER_COVER_MAPPING_NEW
  },
  {
    product: "Deluxe Cover - 2 in 1 Ortho Calm Elite Dog Bed",
    ids: [10286955331880],
    mappingnew: DELUX_ORTHO_CALM_ELITE_BED_COVER_MAPPING_NEW
  },
  {
    product: "2 in 1 Ortho Smart Dog Bed Cover",
    ids: [10278448759080],
    mappingnew: ORTHO_SMART_BED_COVER_MAPPING_NEW
  },
  {
    product: "Next Gen Ortho Lounger Dog Bed Cover",
    ids: [10278448693544],
    mappingnew: ORTHO_LOUNGER_COVER_MAPPING_NEW
  },
  {
    product: "Ortho Calm Elite Dog Bed Replacement Cover",
    ids: [10278448628008],
    mappingnew: ORTHO_CALM_ELITE_BED_COVER_MAPPING_NEW
  }
  
]

window.mappingnew1 = [
{
    product: "Formfit",
    ids: [9018885996840],
    mappingnew: FORMFIT_MAPPING_NEW_1
  }, 
]

let bedding_labels = ["Ortho smart bed", "Ortho lounger", "Elite smart bed", "Thermacore Orthopaedic Dog Bed", "Deluxe Ortho Smart Dog Bed Cover", "Deluxe Next Gen Ortho Lounger Dog Bed Cover", "Deluxe Cover - 2 in 1 Ortho Calm Elite Dog Bed", "2 in 1 Ortho Smart Dog Bed Cover", "Next Gen Ortho Lounger Dog Bed Cover", "Ortho Calm Elite Dog Bed Replacement Cover"];
let formfit_labels = ["Formfit"];

window.bedding_mapping = window.mapping.filter(item => 
  bedding_labels.includes(item.product)
).map(item => item.ids).flat();

window.formfit_mapping = window.mapping.filter(item => 
  formfit_labels.includes(item.product)
).map(item => item.ids).flat();

function removeIcon(event) {
    const emojiRegex = /[\u{1F300}-\u{1F5FF}\u{1F600}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FAFF}\u{1FB00}-\u{1FBFF}]/gu;
    
    const inputElement = $(event.target); // Access the input element
    const inputVal = inputElement.val();

    if (emojiRegex.test(inputVal)) {
        inputElement.val(inputVal.replace(emojiRegex, ''));
    }
}

$(document).on('input', '#cl-custom-text', removeIcon);
$(document).on('input', '#cl-custom-text_order', removeIcon);

/*
  [ED Dev] Manual "Add name label" price rule — DOM patch.

  Rule (AU):
    - Formfit Mesh Harness  -> "$14.99"
    - Everything else       -> "$19.99"
  Default (before Step 1 is chosen) shows the MAX ($19.99) so customers
  don't see the discounted price by accident.

  Targets:
    - #upsell-popup-price / #upsell-popup-custom-price / #upsell-customise-price
    - .second-section p span (raw hardcoded "$X" spans from popup snippets)
    - ATC button labels: #add-patch-text_new / #add-patch-text_new1 /
      #add-patch-text_order / #add-patch-text_order1
    - Main <sale-price> element on the Personalise Labels product page
      (URL /products/personalised-labels / anything containing "label"
      or "personalise" in the path).

  Formfit context detection:
    - URL path contains "formfit" (e.g. /products/formfit-mesh-harness)
    - OR #button-wrapper_new[data-label-pid] is a known Formfit ID
  Formfit AU product IDs are hardcoded so we don't depend on
  window.mappingnew being loaded before this runs.
*/
(function () {
  var FORMFIT_PRICE = '$14.99';
  var DEFAULT_PRICE = '$19.99';
  var FORMFIT_PRODUCT_IDS = [9018885996840];

  var FORMFIT_SESSION_KEY = 'edLabelStep1Formfit';

  function isFormfitContext(hint) {
    var path = (window.location.pathname || '').toLowerCase();
    if (path.indexOf('formfit') !== -1) return true;
    var pid = parseInt(hint);
    if (pid && FORMFIT_PRODUCT_IDS.indexOf(pid) !== -1) return true;
    // On the labels page, remember the last Formfit/non-Formfit selection
    // across page reloads so refresh doesn't reset the price to the default.
    try {
      if (sessionStorage.getItem(FORMFIT_SESSION_KEY) === '1') return true;
    } catch (e) {}
    return false;
  }

  function persistContextFor(hint) {
    try {
      var pid = parseInt(hint);
      if (pid && FORMFIT_PRODUCT_IDS.indexOf(pid) !== -1) {
        sessionStorage.setItem(FORMFIT_SESSION_KEY, '1');
      } else if (pid) {
        sessionStorage.removeItem(FORMFIT_SESSION_KEY);
      }
    } catch (e) {}
  }

  function rewritePrices(hint) {
    // Only run on product pages. Collection pages, home, cart etc. must
    // never have their price nodes touched — collection cards show
    // "From $XX.XX" per product's own smallest variant and must remain
    // authoritative.
    if ((window.location.pathname || '').indexOf('/products/') !== 0) return;

    var price = isFormfitContext(hint) ? FORMFIT_PRICE : DEFAULT_PRICE;

    // 1) Header/summary spans that contain ONLY a dollar amount.
    var moneyOnly = [
      '#upsell-popup-price',
      '#upsell-popup-custom-price',
      '#upsell-customise-price',
      '.second-section p span'
    ];
    document.querySelectorAll(moneyOnly.join(',')).forEach(function (el) {
      var t = (el.textContent || '').trim();
      if (/^\$?\d+(\.\d{1,2})?$/.test(t)) {
        el.textContent = ' ' + price;
      }
    });

    // 2) ATC button labels ("ADD TO CART - $X.XX") + <sale-price> on the
    //    labels product page — regex-replace so surrounding text is kept.
    //    These ONLY run on the Personalise Labels product page. On an
    //    individual harness product page, the popup's own JS already
    //    calculates "product + label" totals correctly, and rewriting the
    //    ATC to just the label price would break that.
    var pathIsLabels = /(personalise|personalised|label)/i.test(window.location.pathname);
    var regexTargets = [];
    if (pathIsLabels) {
      regexTargets.push(
        '#add-patch-text_new',
        '#add-patch-text_new1',
        '#add-patch-text_order',
        '#add-patch-text_order1',
        // Scope tightly to the main product's price container so we DON'T
        // touch cart drawer / cart page line-item prices, which come from
        // the actual (correct) variant price.
        '#product-price-list sale-price'
      );
    }
    if (!regexTargets.length) return;
    document.querySelectorAll(regexTargets.join(',')).forEach(function (el) {
      var t = el.textContent || '';
      if (/\$\d+(\.\d{1,2})?/.test(t)) {
        // Use a function replacement so `price` is treated literally.
        // Passing a string like "$19.99" would let JS interpret "$1" as
        // the first capture group (".99"), producing ".999.99".
        el.textContent = t.replace(/\$\d+(\.\d{1,2})?/, function () { return price; }).replace('Sale price', '');
      }
    });
  }

  function boot() {
    var wrapper = document.getElementById('button-wrapper_new');
    rewritePrices(wrapper ? wrapper.getAttribute('data-label-pid') : null);

    if (wrapper) {
      // Persist initial selection (if any) too
      persistContextFor(wrapper.getAttribute('data-label-pid'));
      new MutationObserver(function (muts) {
        muts.forEach(function (m) {
          if (m.type === 'attributes' && m.attributeName === 'data-label-pid') {
            var newPid = wrapper.getAttribute('data-label-pid');
            persistContextFor(newPid);
            rewritePrices(newPid);
          }
        });
      }).observe(wrapper, { attributes: true, attributeFilter: ['data-label-pid'] });
    }

    // Safety net for late-rebuilt price nodes.
    setTimeout(function () { rewritePrices(wrapper ? wrapper.getAttribute('data-label-pid') : null); }, 500);
    setTimeout(function () { rewritePrices(wrapper ? wrapper.getAttribute('data-label-pid') : null); }, 1500);
    setTimeout(function () { rewritePrices(wrapper ? wrapper.getAttribute('data-label-pid') : null); }, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();